/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Monitoring API
 * Monitoring API for working with device errors
 *
 * The version of the OpenAPI document: 1.20.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The last unexpected reset state representation model
 * @export
 * @interface UnexpectedResetState
 */
export interface UnexpectedResetState {
    /**
     * @type {Date}
     * @memberof UnexpectedResetState
     */
    reset_time?: Date;
    /**
     * @type {string}
     * @memberof UnexpectedResetState
     */
    trace_id?: string;
}
